/******************************************************************************
 * This file was generated by langium-cli 4.2.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

import type { LangiumSharedCoreServices, LangiumCoreServices, LangiumGeneratedCoreServices, LangiumGeneratedSharedCoreServices, LanguageMetaData, Module } from 'langium';
import { MermaidAstReflection } from './ast.js';
import { ArchitectureGrammarGrammar, GitGraphGrammarGrammar, InfoGrammarGrammar, PacketGrammarGrammar, PieGrammarGrammar, RadarGrammarGrammar, TreemapGrammarGrammar } from './grammar.js';

export const ArchitectureGrammarLanguageMetaData = {
    languageId: 'architecture',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const GitGraphGrammarLanguageMetaData = {
    languageId: 'gitGraph',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const InfoGrammarLanguageMetaData = {
    languageId: 'info',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const PacketGrammarLanguageMetaData = {
    languageId: 'packet',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const PieGrammarLanguageMetaData = {
    languageId: 'pie',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const RadarGrammarLanguageMetaData = {
    languageId: 'radar',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const TreemapGrammarLanguageMetaData = {
    languageId: 'treemap',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const MermaidGeneratedSharedModule: Module<LangiumSharedCoreServices, LangiumGeneratedSharedCoreServices> = {
    AstReflection: () => new MermaidAstReflection()
};

export const ArchitectureGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => ArchitectureGrammarGrammar(),
    LanguageMetaData: () => ArchitectureGrammarLanguageMetaData,
    parser: {}
};

export const GitGraphGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => GitGraphGrammarGrammar(),
    LanguageMetaData: () => GitGraphGrammarLanguageMetaData,
    parser: {}
};

export const InfoGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => InfoGrammarGrammar(),
    LanguageMetaData: () => InfoGrammarLanguageMetaData,
    parser: {}
};

export const PacketGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => PacketGrammarGrammar(),
    LanguageMetaData: () => PacketGrammarLanguageMetaData,
    parser: {}
};

export const PieGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => PieGrammarGrammar(),
    LanguageMetaData: () => PieGrammarLanguageMetaData,
    parser: {}
};

export const RadarGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => RadarGrammarGrammar(),
    LanguageMetaData: () => RadarGrammarLanguageMetaData,
    parser: {}
};

export const TreemapGrammarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => TreemapGrammarGrammar(),
    LanguageMetaData: () => TreemapGrammarLanguageMetaData,
    parser: {}
};
